import React, { createContext, useContext, useState, useEffect } from 'react';
import { notification } from 'antd';

const ClipboardContext = createContext();

export const useClipboard = () => useContext(ClipboardContext);

export const ClipboardProvider = ({ children }) => {
    const [accumulatedTexts, setAccumulatedTexts] = useState([]);

    const addText = (text) => {
        setAccumulatedTexts(prev => {
            const texts = [...prev, text];
            navigator.clipboard.writeText(texts.join('\n'));
            notification.success({
                message: 'Copied to clipboard',
                description: `${texts.length} texts copied`,
                placement: 'topRight',
                duration: 2
            });
            return texts;
        });
    };

    const copyAndClear = () => {
        if (accumulatedTexts.length > 0) {
            setAccumulatedTexts([]);
        }
    };

    useEffect(() => {
        const handleLeftClick = (e) => {
            copyAndClear();
        };

        document.addEventListener('click', handleLeftClick);

        return () => {
            document.removeEventListener('click', handleLeftClick);
        };
    }, [accumulatedTexts]); // dependency to re-add if needed, but since copyAndClear clears, maybe not

    return (
        <ClipboardContext.Provider value={{ addText }}>
            {children}
        </ClipboardContext.Provider>
    );
};